import React from 'react';
import { useState } from 'react';
import axios from 'axios';
import { LiaTimesSolid } from 'react-icons/lia';
// import OpenandCloseModal from '../TradeCurrency/OpenandCloseModal';
import { LoadingMode } from '../Components/LoadingMode';
import { getToken } from '../utils';
import { toast } from 'react-toastify';

function ModalWithdrawBonus({ handleOpenandCloseModal }) {
  const initialise = { amount: '' };
  const [input, setInput] = useState(initialise);
  const [isSubmiting, setIsSubmiting] = useState(false);
  const { token: userToken } = getToken();

  const handleChange = (e) => {
    const target = e.target;
    const { value, name } = target;
    setInput((input) => ({
      ...input,
      [name]: value,
    }));
  };

  const handleSubmitBonusAmount = async (e) => {
    e.preventDefault();

    try {
      setIsSubmiting(true);
      const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/referrals/withdrawal-store`,
        input,
        {
          headers: { Authorization: `Bearer ${userToken}` },
        }
      );

      setInput(initialise);
      toast.success(response.data.message, {
        autoClose: 2000,
      });
    } catch (error) {
      console.log(error);
      toast.error(error.message, {
        autoClose: 3000,
      });
    } finally {
      setIsSubmiting(false);
    }
  };

  return (
    <div className='bg-p-wh shadow-lg py-8 w-[25rem] relative top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 rounded'>
      <h2 className='font-semibold text-[18px] pb-2 mb-6 border-b-hf px-6'>
        Withdraw Bonus
      </h2>
      <span
        className='absolute right-6 top-6 text-2xl  text-s-bk cursor-pointer hover:text-p-bk'
        onClick={() => handleOpenandCloseModal('close')}
      >
        <LiaTimesSolid />
      </span>
      <form
        className='flex flex-col mx-6 gap-2'
        onSubmit={handleSubmitBonusAmount}
      >
        <label className='text-s-bk'>Enter Amount</label>
        <input
          type='number'
          name='amount'
          value={input.amount}
          className='border-hf px-2 h-11 w-full rounded focus:outline-none focus:ring focus:b-mc [appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none'
          onChange={handleChange}
          placeholder='0.00'
        />
        <div className='mt-6 w-full'>
          <button
            type='submit'
            className='text-p-wh justify-center disabled:text-f-bk hover:bg-b-mc/75 focus:bg-b-mc/80 w-full py-2 disabled:bg-b-mct bg-b-mc rounded relative'
            disabled={isSubmiting ? isSubmiting : input.amount === ''}
          >
            Withdraw
            {isSubmiting && <LoadingMode />}
          </button>
        </div>
      </form>
    </div>
  );
}

export default ModalWithdrawBonus;
